import { DataType } from "../models/flexible/data-type";
import { DataControllerProps } from "../models/flexible/flex-field-controller";
import { isEmptyValue } from "./is-empty-value";
import { localeDate } from "./locale-date";
import { neo4jDateToDate } from "./neo4j-date-to-date";
import { TrFun } from "./types";

export function formatFieldValue(value: any, dataType: DataType, translate: TrFun) {
	if (isEmptyValue(value)) {
		return value;
	}

	switch (dataType) {
		case DataType.Boolean: {
			if (Array.isArray(value)) {
				return value.map((item) => translate(item === true || item === "true" ? "yes" : "no")).join(", ");
			}

			return translate(value === true || value === "true" ? "yes" : "no");
		}

		case DataType.Date:
			return Array.isArray(value)
				? value.map((date) => localeDate(neo4jDateToDate(date))).join(", ")
				: localeDate(neo4jDateToDate(value));

		case DataType.Number:
			return `${value}`;

		case DataType.Text: {
			if (Array.isArray(value)) {
				return value.map((item) => translate(item === "true" ? "yes" : item === "false" ? "no" : item)).join(", ");
			}

			return value && translate(String(value) === "true" ? "yes" : value === "false" ? "no" : value);
		}

		default:
			return value;
	}
}

export function getFormattedListLabel(value: any, controlProps: DataControllerProps): string {
	if (isEmptyValue(value)) {
		return value;
	}

	if (Array.isArray(value)) {
		return value.map((element) => element[controlProps.property]).join(", ");
	}

	return value[controlProps.property];
}

const getValueByProperty = (value: any, property: string) => {
	if (isEmptyValue(value)) {
		return value;
	}

	return Array.isArray(value) ? value.map((element) => element[property]).filter((value) => value != null) : value[property];
};

export const formatDataPoint = (value: any, dataController: any, dataType: DataType, t: TrFun): any => {
	if (dataController?.translationPrefix) {
		return formatFieldValue(`${dataController.translationPrefix}${value}`, dataType, t);
	}

	const fieldValue =
		dataController !== null && (dataController?.controlType === "combo" || dataController?.controlType === "typeahead")
			? getValueByProperty(value, dataController.property)
			: value;

	return formatFieldValue(fieldValue, dataType, t);
};
